import React from 'react';
import moment from 'moment';
import { connect } from 'react-redux';
import { Event, EventRegistration } from 'resources';
import actionProps from 'actions';

import { Button } from 'react-bootstrap';
import { Form, Field } from 'components/form';
import { Photos, CustomEventQuestions } from 'components/event';

import RegistrationClosed from './_registration_closed';

class UnauthenticatedRegisterIndex extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      authorization: null,
      event: null,
      eventRegistration: {
        variable_amount: 0,
      },

      ready: false,
      cardType: 'unknown',
      isLoading: false,
      validityErrors: {},
    };
  }

  componentDidMount() {
    this.doObjectRetrieve();
  }

  onChange = (e) => {
    const value = e.target.value;
    const name = e.target.name.split('.')[1];

    this.setState(state => {
      const newState = _.clone(state);
      newState.eventRegistration[name] = value;
      newState.error = null;
      return newState;
    });
  }

  onChangeEventAnswer = (value, index, field = 'answer') => {
    const { eventRegistration } = this.state;
    _.set(eventRegistration, `event_answers.[${index}].${field}`, value);
    this.setState({ eventRegistration });
  }

  onChangeEventCheckboxAnswer = (target, index) => {
    const { eventRegistration } = this.state;
    const newValue = target.checked ?
      [..._.get(eventRegistration, `event_answers.[${index}].answer`, []), target.value] :
      _.remove(_.get(eventRegistration, `event_answers.[${index}].answer`, []), ans => ans !== target.value);
    _.set(eventRegistration, `event_answers.[${index}].answer`, newValue);
    this.setState({ eventRegistration });
  }

  onProcessCreate = () => {
    const { eventRegistration, event } = this.state;
    this.setState({ ready: false });

    EventRegistration.createPublic({
      data: {
        event_registration: {
          event_id: event.id,
          name: eventRegistration.name || '',
          email: eventRegistration.email || '',
          tickets: eventRegistration.tickets,
          event_answers: eventRegistration.event_answers || [],
          event_optional_addons: eventRegistration.event_optional_addons || [],
          braintree_nonce: eventRegistration.braintree_nonce,
          variable_amount: eventRegistration.variable_amount,
        },
      },
      onSuccess: ({ data }) => {
        this.props.actions.routePush(`/submit/${data.id}/confirmation`);
      },
      onFailure: ({ data }) => {

        this.setState({
          ready: true,
          error: _.get(data, 'event_registration'),
        });
      },
    });
  }

  onValidityErrorChange = (field, validity) => {
    const { validityErrors } = this.state;

    if (validity) {
      delete validityErrors[field];
    } else {
      validityErrors[field] = true;
    }

    this.setState({ validityErrors });
  }

  objectQuery = `
    event {
      name
      description
      event_questions
      registration_closes_on
      background_color
      header_color

      document_folder {
        documents {
          url
        }
      }

      owner {
        primary_logo {
          public_url
        }
        secondary_logo {
          public_url
        }
      }
    }
  `

  doObjectRetrieve = () => {
    let { eventRegistration } = this.state;

    Event.retrievePublic({
      id: this.props.params.id,
      query: this.objectQuery,
      onSuccess: ({ data }) => {
        eventRegistration = {
          ...eventRegistration,
          event_answers: data.event_questions,
          event_optional_addons: data.optional_addons,
        };

        this.setState({
          event: data,
          eventRegistration,
        });

        this.props.actions.setCustomWrapperStyles({
          backgroundColor: _.get(data, 'background_color', null),
          headerColor: _.get(data, 'header_color', null),
          primaryLogo: _.get(data, 'owner.primary_logo.public_url', null),
          secondaryLogo: _.get(data, 'owner.secondary_logo.public_url', null),
        });

      },
    });
  }

  render() {
    const { openModal, closeModal } = this.props.actions;
    const { event, error } = this.state;

    if (!event) {
      return null;
    }

    if (moment(event.registration_closes_on).endOf('day').isBefore(moment())) {
      return (
        <RegistrationClosed
          event={event}
        />
      );
    }

    const btnStyles = {
      backgroundColor: event.header_color,
      borderColor: event.header_color,
    };

    return (
      <div className="account-wrapper account-wrapper-wide">

        <h3>{_.get(event, 'name')}</h3>

        <div className="account-form account-body">
          <Form
            action={() => {}}
            onSuccess={() => {}}
          >

            <Photos event={event} isPublic />

            <p
              dangerouslySetInnerHTML={{ __html: _.get(event, 'description') }}
              className="m-b-2"
            />

            <hr />

            <Field
              labelClassName="col-md-12"
              inputSize={6}
              name="event_registration.name"
              hint={_.get(error, 'name.[0]')}
              validationState={_.get(error, 'name.[0]') && 'error'}
              onChange={this.onChange}
              label={
                <span>
                  <span className="text-danger">* </span>
                  Your name:
                </span>
              }
              autoFocus
            />

            <Field
              labelClassName="col-md-12"
              inputSize={6}
              name="event_registration.email"
              hint={_.get(error, 'email.[0]')}
              validationState={_.get(error, 'email.[0]') && 'error'}
              onChange={this.onChange}
              label={
                <span>
                  <span className="text-danger">* </span>
                  Your email:
                </span>
              }
            />

            <hr />

            <CustomEventQuestions
              event={event}
              errors={_.get(error, 'event_answers.[0]')}
              onChangeEventAnswer={this.onChangeEventAnswer}
              onChangeEventCheckboxAnswer={this.onChangeEventCheckboxAnswer}
              labelClassName="col-md-12"
              inputSize={6}
              openModal={openModal}
              closeModal={closeModal}
            />

            <div className="m-l-05 form-group">
              <Button
                type="submit"
                bsStyle="primary"
                onClick={() => this.onProcessCreate()}
                style={btnStyles}
              >
                Submit
              </Button>
            </div>

          </Form>

        </div>
      </div>
    );
  }

}

export default connect(null, actionProps)(UnauthenticatedRegisterIndex);
